var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:(_vm.color + "--text")},[_vm._v("\n  "+_vm._s(_vm.rankValue)),_c('span',{staticClass:"suit"},[_vm._v(_vm._s(_vm.suitSymbol))])])}
var staticRenderFns = []

export { render, staticRenderFns }